import Container from '@/components/global/Container';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentBlocksEmbedHtml } from '@/graphql/__generated__/global/types';

const BlockEmbedHtml = ({ embedCode, titleDescription }: IComponentBlocksEmbedHtml) => {
    if (!embedCode) {
        return;
    }

    return (
        <Container>
            {titleDescription && <TitleAndDescription {...titleDescription} />}
            {embedCode && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: embedCode,
                    }}
                />
            )}
        </Container>
    );
};

export default BlockEmbedHtml;
